<template>
  <div class="grid-container full page-contents-8">
      <div class="left text-left">
        <h2>As seen in</h2>
      </div>

      <div class="center text-center">
        <a href="https://www.theguardian.com/education/2022/dec/25/uk-scheme-supporting-black-students-to-reach-oxbridge-expands-to-nursery-schools" target="_blank" rel="noopener">
          <img src="@/assets/img/hemisphereImages/guardian.png" class="guardian" alt="The Gaurdian" />
        </a>
      </div>

      <div class="right text-right">
        <a href="https://www.fnlondon.com/articles/are-you-racist-city-giants-use-software-that-calls-out-biases-20221214?mod=Searchresults" target="_blank" rel="noopener">
          <img src="@/assets/img/hemisphereImages/financial-news.png" class="financial-news" alt="Financial News" />
        </a>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HomeProductsCrsDataRow',
  props: {
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: $mid-grey-background;
  }

  h2 {
    color: $white-text;
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: 0.02em;
  }

  @media only screen and (max-width: 800px)  {
    .full {
      height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }

    h2 {
      font-size: 50px;
      line-height: 1;
      letter-spacing: normal;
      margin: 0;
      text-align: center;
    }

    .guardian {
      width: 164px;
    }

    .financial-news {
      width: 240px;
    }

  }

  @media only screen and (min-width: 800px) {
    .full {
      height: 145px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left {
      width: 32%;
    }

    .center {
      width: 32%;
    }

    .right {
      width: 32%;
    }

    .guardian {
      width: 164px;
    }

    .financial-news {
      width: 240px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsHemisphere/components/HomeProductsHemisphereMediaRow.vue